import { GetAuditorDto } from '@studyportals/campaign-management-api-interface';

enum EntityKeys {
	STUDY = 's',
	ORGANISATION = 'o'
}

interface IAuditorGeoData {
	c: {
		p: number;
		lp: number;
		sp: number;
		b: number;
	};
	[EntityKeys.STUDY]: number;
	[EntityKeys.ORGANISATION]: number;
}

interface IAuditorPricingCluster {
	[key: string]: number;
}

interface IAuditorPricingData {
	[EntityKeys.STUDY]: IAuditorPricingCluster;
	[EntityKeys.ORGANISATION]: IAuditorPricingCluster;
}

interface IAuditorGeoReminders {
	[EntityKeys.STUDY]: number;
	[EntityKeys.ORGANISATION]: number;
}

interface IAuditorData {
	geo: IAuditorGeoData[];
	pricing: IAuditorPricingData;
	_geo_remainders: IAuditorGeoReminders;
}

interface IRefinedAuditorEntry extends GetAuditorDto {
	refinedData?: IAuditorData;
}
interface IRefinedVerifiedAuditorEntry extends GetAuditorDto {
	refinedData: IAuditorData;
}

export { IAuditorData, IRefinedAuditorEntry, IRefinedVerifiedAuditorEntry, IAuditorPricingCluster, EntityKeys };
